import customAxios from '../../customAxios';

import { COMPANY_PAY_FACTORS_IS_NEED_PAY_2_COMPANY } from '../../routes';

const priceFactorsIsNeedpay2Company = async () => {
  try {
    return (await customAxios.get(COMPANY_PAY_FACTORS_IS_NEED_PAY_2_COMPANY)).data;
  } catch (error: any) {
    console.log({ COMPANY_PAY_FACTORS_IS_NEED_PAY_2_COMPANY: error });
  }
};

export default priceFactorsIsNeedpay2Company;
